module.exports = __webpack_public_path__ + "static/media/Jenkins.64f7bcb4.png";